var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.onResize,
          expression: "onResize"
        }
      ],
      attrs: { syle: "overflow-y: hidden" }
    },
    [
      _c(
        "div",
        { staticClass: "d-flex align-center justify-center my-2" },
        [
          _vm.interventionId
            ? _c(
                "v-chip",
                {
                  staticClass: "mr-8",
                  attrs: { small: "", close: "" },
                  on: { "click:close": _vm.onInterventionClose }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.generateMessageFunction(
                          "properties.documents.interventionId",
                          {
                            interventionId: _vm.interventionId
                          }
                        )
                      ) +
                      "\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("custom-btn-icon", {
            attrs: {
              "btn-text": "Ajouter un document",
              color: "success",
              icon: "mdi-plus",
              disabled: !!_vm.error
            },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.openDialog.apply(null, arguments)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1 secondarybackground striped-table clickable",
        attrs: {
          "fixed-header": "",
          "disable-pagination": "",
          "hide-default-footer": "",
          "multi-sort": "",
          "sort-by": _vm.sortBy,
          "sort-desc": _vm.sortDESC,
          "server-items-length": _vm.items.length,
          height: _vm.height,
          headers: _vm.headers,
          loading: _vm.loader,
          items: _vm.items,
          "no-data-text": _vm.noDataText
        },
        on: {
          "update:sortBy": function($event) {
            _vm.sortBy = $event
          },
          "update:sort-by": function($event) {
            _vm.sortBy = $event
          },
          "update:sortDesc": function($event) {
            _vm.sortDESC = $event
          },
          "update:sort-desc": function($event) {
            _vm.sortDESC = $event
          },
          "click:row": _vm.download
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [_c("property-header")]
            },
            proxy: true
          },
          {
            key: "item.actions",
            fn: function({ item }) {
              return [
                item.internal
                  ? _c(
                      "v-btn",
                      {
                        attrs: {
                          small: "",
                          icon: "",
                          color: "error",
                          loading: _vm._f("isLoading")(item, _vm.deleting)
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.deleteItem(item)
                          }
                        }
                      },
                      [_c("v-icon", [_vm._v("mdi-delete")])],
                      1
                    )
                  : _vm._e()
              ]
            }
          },
          {
            key: "item.category_id",
            fn: function({ item }) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.categories.find(el => el.id === item.category_id)
                        .title
                    ) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "item.nature_id",
            fn: function({ item }) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.categories
                        .find(el => el.id === item.category_id)
                        .natures.find(
                          el =>
                            el.id ===
                            item.nature_id.slice(item.nature_id.indexOf("N"))
                        ).title
                    ) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "item.last_update_datetime",
            fn: function({ item }) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      new Date(item.last_update_datetime).toLocaleString()
                    ) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "item.file_length",
            fn: function({ item }) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("formatBytes")(item.file_length)) +
                    "\n    "
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }